import { Component, OnInit } from '@angular/core';
import { MetamanagerService } from '../metamanager.service';
import { InitScripts } from '../app.constants';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.css']
})
export class DisclaimerComponent implements OnInit {
  constructor(private metaManager: MetamanagerService) {
    new InitScripts().loadScripts();
  }

  ngOnInit(): void {
    this.metaManager.updateMetaTitle("Disclaimer Detail | sarvadhnya.com",
      "आदिकरण श्री दत्तात्रेय प्रभू, श्री गुरुवर्य आणि अखिल परमार्ग",
      "");
  }
}
